<template>
  <v-dialog
    v-model="dialog"
    max-width="600"
    persistent
    :fullscreen="$vuetify.breakpoint.mobile"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-if="inDocumentVerificationRoutes" v-on="on" v-bind="attrs" small>
        <v-icon>mdi-shield-check-outline</v-icon>
      </v-btn>
      <v-btn
        v-else
        color="primary"
        v-on="on"
        v-bind="attrs"
        :disabled="disabled"
      >
        Analisar Documentos
      </v-btn>
    </template>
    <v-card>
      <v-toolbar flat tile class="flex-grow-0">
        <v-toolbar-title class="title">
          {{ $t("validatingDocument") }}
        </v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="mx-auto mt-4">
        <div class="pa-4 px-2" v-if="documents.length > 0">
          <div v-for="(document, i) in documents" :key="document.name">
            <div :class="i == 0 ? 'mt-0' : 'mt-8'" style="overflow: auto;">
              <p class="text-body-1 ">
                {{ document.name }}
              </p>

              <v-img
                v-if="!document.pdf"
                :src="document.src"
                max-height="320"
                max-width="320"
                class="mx-auto"
              />

              <pdf
                v-else
                :src="document.src"
                :key="i + updatePdfKey"
                :id="i"
                :page="1"
                style="max-width: 100%; max-height: 100%;"
              />
            </div>
          </div>
        </div>
        <v-skeleton-loader
          v-else
          type="image"
          max-width="100%"
          max-height="300"
          class="mx-auto"
        />
      </v-card-text>
      <v-card-actions
        v-if="confirmingValidation"
        class="grey darken-3 white--text"
      >
        <v-spacer></v-spacer>
        <span class="mr-2">
          {{
            $t("confirmPlayerValidation", {
              userId,
              type: denyingPlayer
                ? $t("lowerCaseDeny")
                : $t("lowerCaseValidate"),
            })
          }}
        </span>
        <v-btn depressed @click="validateDocument" color="info">
          {{ $t("yes") }} &nbsp;
        </v-btn>

        <v-btn
          depressed
          @click="confirmingValidation = false"
          class="white--text"
        >
          {{ $t("no") }} &nbsp;
        </v-btn>
      </v-card-actions>
      <v-card-actions v-else>
        <v-spacer></v-spacer>
        <v-btn
          @click.prevent="dialog = false"
          :loading="loading"
          :disabled="loading"
        >
          {{ $t("toCancel") }}
        </v-btn>
        <v-btn
          color="red"
          @click.prevent="beforeValidateDocument('deny')"
          :loading="loading || validatingPlayer"
          :disabled="loading || documents.length === 0 || validatingPlayer"
        >
          {{ $t("deny") }}
        </v-btn>
        <v-btn
          color="primary"
          @click.prevent="beforeValidateDocument('ok')"
          :loading="loading || validatingPlayer"
          :disabled="loading || documents.length === 0 || validatingPlayer"
        >
          {{ $t("accept") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import pdf from "pdfvuer";

import AWS from "aws-sdk";
const bucketName = "sga-assets";
const bucketRegion = "sa-east-1";
const creds = new AWS.Credentials({
  accessKeyId: "accessKeyId",
  secretAccessKey: "secretAccessKey",
});

AWS.config.update({
  region: bucketRegion,
  credentials: creds,
});

const s3 = new AWS.S3({
  apiVersion: "2006-03-01",
  params: { Bucket: bucketName },
});

const domain = localStorage.getItem("operator");

export default {
  props: ["userId", "disabled"],

  data: () => ({
    dialog: false,
    loading: false,
    documents: [],
    validatingPlayer: false,
    confirmingValidation: false,
    denyingPlayer: false,
    updatePdfKey: 0,
  }),

  created() {
    this.fetchDocuments();
  },

  components: { pdf },

  computed: {
    operatorUrl() {
      try {
        let operatorUrl = this.$operator.url;
        if (operatorUrl.slice(-1) == "/") {
          operatorUrl = operatorUrl.slice(0, -1);
        }

        return operatorUrl;
      } catch (e) {
        return "";
      }
    },
    inDocumentVerificationRoutes() {
      const documentVerificationRoutes = [
        "DocumentVerification",
        "CollaboratorDocumentVerification",
      ];

      return documentVerificationRoutes.includes(this.$route.name);
    },
  },

  watch: {
    dialog(val) {
      if (val) {
        this.documents = [];
        this.fetchDocuments();
      } else {
        this.loading = false;
      }
    },
  },

  methods: {
    beforeValidateDocument(type) {
      this.denyingPlayer = type === "deny";
      this.confirmingValidation = true;
    },
    validateDocument() {
      this.confirmingValidation = false;
      this.validatingPlayer = true;

      const userData = JSON.parse(localStorage.getItem("user_data"));
      const isCollaborator = userData.isCollaborator;

      const controllerPrefix = isCollaborator ? "colab" : "administrator";
      const endpoint = this.denyingPlayer
        ? "denyPlayerDocument"
        : "validatePlayerDocument";

      this.$axios
        .post(
          `/${controllerPrefix}/players/${endpoint}`,
          this.$formdata({ id_user: this.userId })
        )
        .then((res) => {
          if (this.inDocumentVerificationRoutes === false) {
            this.$emit(
              "updateDocumentVerification",
              this.denyingPlayer ? 4 : 3
            );
          }

          this.$store.commit("setFeedbackSnack", {
            msg: res.data.messages,
            color: "success",
          });
        })
        .catch((err) => {
          this.$store.commit("setFeedbackSnack", {
            msg: err.response.data.messages.error,
            color: "warning",
          });
        })
        .finally(() => {
          this.validatingPlayer = false;
          this.dialog = false;

          if (this.inDocumentVerificationRoutes) {
            this.$emit("refreshPlayers");
          }
        });
    },
    fetchDocuments() {
      this.updatePdfKey += 1;

      const assetsBaseUrl = "https://sga-assets.s3.sa-east-1.amazonaws.com/";
      const imagePath = `domains/${domain}/img/documentVerification/${this.userId}`;

      s3.listObjects({
        Prefix: imagePath,
      })
        .promise()
        .then((res) => {
          const documents = res.Contents;

          const front = { src: "", name: "", pdf: "" };
          const verse = { src: "", name: "", pdf: "" };
          const face = { src: "", name: "", pdf: "" };

          documents.forEach((document) => {
            if (document.Key.includes("documento.")) {
              front.src = `${assetsBaseUrl}${document.Key}`;
              front.name = this.$t("documentFront");
              front.pdf = document.Key.includes("pdf");
            } else if (document.Key.includes("documento_verso.")) {
              verse.src = `${assetsBaseUrl}${document.Key}`;
              verse.name = this.$t("documentVerse");
              verse.pdf = document.Key.includes("pdf");
            } else if (document.Key.includes("biometria_face.")) {
              face.src = `${assetsBaseUrl}${document.Key}`;
              face.name = this.$t("faceBiometry");
              face.pdf = document.Key.includes("pdf");
            }
          });

          this.documents = [front, verse, face];
        });
    },
  },
};
</script>
